
    import '/mnt/src/components/Cell/index.md?watch=parent';
    export const demoIndex = {
  ids: ["cell-demo-demo","cell-demo-demo2"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Cell/index.md?type=demo')
};